import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('abonnement')
export class Subscription {
  @JsonProperty('idTelematiqueClient', String, true)
  public customerTelematicsId = '';
}
